import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../../Shared/REST';
import Helpers from "../../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../../Shared/Consts";
import queryString from 'query-string';

import logo_kidspeak from '../../assets/images/logo_kidspeak.png';

import "./style/style.css";
import HeaderComponent from "../../Shared/Header";
import connect from "react-redux/es/connect/connect";
import DialogBox from "../../Shared/DialogBox";
import DeleteDialogBox from "../../Shared/DeleteDialogBox";
import DropDownNotifications from "../../Shared/DropDownNotifications";
import ReportBugForm from "../../ModalFormComponents/ReportBugForm";
import {updateStudent} from "../actions";
import closeRedX from "../../assets/images/modal_x.png";
import TRACKING from "../../Shared/DataTrackingPoints";
import {Modal} from "react-bootstrap";

class KSGrading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bestScores: null,
            gradeStart:null,
            audioSrc: "",
            audioBlob: false,
            storyStarter: {},
            currentTime:"0.00",
            duration:"0.00",
            endIndex:0,
            score:0,
            correct:0,
            incorrect:0,
            paragraphs:[],
            highlighted:-1,
            timer:null,
            progressBar:{
                width:null
            },
            playButton:{
                backgroundImage:null
            },
            playButtonHover:null,
            playButtonLeave:null,
            ksSession:null,
            modalDialog:false,
            responseContent:'',
            modalDialogDelete: false,
            modalDialogNote: false,
            noteContent:'',
            handleNext: false,
            taskID:null,
            showPlayHint:false,
            showClickWrongHint: false,
            showClickLastHint: false,
            showClickSingleHint: false,
            showClickDoubleHint: false,
            showSaveHint: false,
            sessionData: {
                testId: 0,
                gradingData: "",
                gradingTime: 0,
                numberCorrect: 0,
                numberIncorrect: 0
            },
            analytics: {
                type: null,
                metadata: null,
            }
        };

        this.startGrading = this.startGrading.bind(this);
        this.submitKSSessionGrade = this.submitKSSessionGrade.bind(this);
        this.initializeData = this.initializeData.bind(this);
        this.calculateScore = this.calculateScore.bind(this);
        this.mouseClick = this.mouseClick.bind(this);
        this.mouseDblClick = this.mouseDblClick.bind(this);
        this.wrongTickMark = this.wrongTickMark.bind(this);
        this.correctTickMark = this.correctTickMark.bind(this);
        this.fillWithChecks = this.fillWithChecks.bind(this);
        this.clearCounters = this.clearCounters.bind(this);
        this.pausePlay = this.pausePlay.bind(this);
        this.clickedBar = this.clickedBar.bind(this);
        this.update = this.update.bind(this);
        this.updateKSBestScore = this.updateKSBestScore.bind(this);
        this.deleteScore = this.deleteScore.bind(this);
        this.handleTakeANote = this.handleTakeANote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.handleNoteClose = this.handleNoteClose.bind(this);
        this.handleNoteContentChange = this.handleNoteContentChange.bind(this);
        this.keyDownListener = this.keypress.bind(this);
        this.handleStudentClick = this.handleStudentClick.bind(this);
        this.handleNextTask = this.handleNextTask.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.getTarget1 = this.getTarget1.bind(this);
        this.getTarget2 = this.getTarget2.bind(this);
        this.getTarget3 = this.getTarget3.bind(this);
        this.getTarget4 = this.getTarget4.bind(this);
        this.getTarget5 = this.getTarget5.bind(this);
        this.handleShowHints = this.handleShowHints.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    async componentDidMount() {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        await this.setState({
            testId: parsed.testId,
            gradeStart: Date.now(),
            analytics:{
                type: TRACKING.KS_SCORE_VIEW,
                metadata:{testId:parsed.testId}
            }
        });
        this.startGrading(parsed.testId);
        REST.getStudentNotifications().then(res => {
            for(let i = 0; i < res.body.length; i++){
                for(let j=0; j<res.body[i].apps.kidSpeakScores.length; j++){
                    let kidSpeakScores = res.body[i].apps.kidSpeakScores[j];
                    if (kidSpeakScores && kidSpeakScores.userId === this.props.lastStudent.user.id && kidSpeakScores.id != parsed.testId) {
                        this.setState({
                            handleNext: true,
                            taskID: kidSpeakScores.id
                        });
                    }
                }
            }
        });
        this.handleAnalytics();
        document.addEventListener("keydown", this.keyDownListener);
    };

    componentWillUnmount(){
        clearInterval(this.state.timer);
        document.removeEventListener("keydown", this.keyDownListener);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleNextTask(){
        window.location.href = '/teacher/apps/ks-grading?testId=' + this.state.taskID;
    }

    // Event handler for keypress events
    keypress = async (e) => {
        if (e.which === 32) {
            this.pausePlay();
        }
        e.stopImmediatePropagation();
    };

    async updateKSBestScore(){
        if(this.state.bestScores.ksLevel === this.state.ksSession.startLevel
            // && this.state.bestScores.ksScore === this.state.ksSession.startProgress
        ) {
            let newProgress = this.state.bestScores.ksScore;
            let newLevel = this.state.bestScores.ksLevel;
            if (this.state.bestScores.ksLevel === 1) {
                if (this.state.sessionData.numberCorrect >= 1) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.bestScores.ksLevel === 2) {
                if (this.state.sessionData.numberCorrect >= 29) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.bestScores.ksLevel === 3) {
                if (this.state.sessionData.numberCorrect >= 50) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.bestScores.ksLevel === 4) {
                if (this.state.sessionData.numberCorrect >= 84) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.bestScores.ksLevel === 5) {
                if (this.state.sessionData.numberCorrect >= 100) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            } else if (this.state.bestScores.ksLevel === 6) {
                if (this.state.sessionData.numberCorrect >= 103) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 7) {
                if (this.state.sessionData.numberCorrect >= 112) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 8) {
                if (this.state.sessionData.numberCorrect >= 120) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 9) {
                if (this.state.sessionData.numberCorrect >= 132) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 10) {
                if (this.state.sessionData.numberCorrect >= 133) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 11) {
                if (this.state.sessionData.numberCorrect >= 140) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }else if (this.state.bestScores.ksLevel === 12) {
                if (this.state.sessionData.numberCorrect >= 142) {
                    newProgress++;
                } else {
                    newProgress--;
                }
            }


            if (newProgress > 3 && newLevel <= 12) {
                newLevel++;
                newProgress = 1;
            } else if (newProgress === 0) {
                newProgress = 1;
            }

            await this.setState({
                bestScores: {
                    ...this.state.bestScores,
                    ksLevel: newLevel,
                    ksScore: newProgress
                }
            });

            await REST.updateKSBestScore(this.state.bestScores);
        }
    }

    submitKSSessionGrade = async () => {
        let gradingData = "";
        for(let i=0;i<this.state.paragraphs.length;i++){
            if(this.state.paragraphs[i].alt===""){
                gradingData = gradingData+"0"
            }else if(this.state.paragraphs[i].alt==="wrong"){
                gradingData = gradingData+"2"
            }else{
                gradingData = gradingData+"1"
            }
            if(i!==this.state.paragraphs.length-1){
                gradingData = gradingData+","
            }
        }

        await this.setState({
            sessionData: {
                testId: this.state.testId,
                gradingData: gradingData,
                gradingTime: Math.ceil((Date.now() - this.state.gradeStart)/1000),
                numberCorrect: this.state.correct,
                numberIncorrect: this.state.incorrect
            }
        });
        console.log("Submitting session data: ", this.state.sessionData);
        await REST.gradeKSSession(this.state.sessionData).then(async(res)=>{
            await this.updateKSBestScore();
            this.setState({
                modalDialog: true,
                responseContent:'Score task saved.',
                analytics: {
                    type: TRACKING.KS_SCORE_SAVE,
                    metadata: {testId: this.state.testId}
                }
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        }).catch(err=>{
            console.log(err);
        });
        this.handleAnalytics();
    };

    // functions to add tick icons
    wrongTickMark(index){
        this.state.paragraphs[index].src = require("./style/images_WordMark/wrong.png");
        this.state.paragraphs[index].alt = "wrong";
        this.state.incorrect = this.state.incorrect + 1;
        this.forceUpdate();
    };

    correctTickMark(index){
        this.state.paragraphs[index].src = require("./style/images_WordMark/correct.png");
        this.state.paragraphs[index].alt = "correct";
        this.state.correct = this.state.correct + 1;
        this.forceUpdate();
    };

    removeMark(index){
        let imgAlt = this.state.paragraphs[index].alt;
        if(imgAlt === "correct"){
            this.state.correct = this.state.correct - 1;
            this.state.paragraphs[index].src="";
            this.state.paragraphs[index].alt="";
        }
        else if(imgAlt === "wrong"){
            this.state.incorrect = this.state.incorrect - 1;
            this.state.paragraphs[index].src="";
            this.state.paragraphs[index].alt="";
        }
        this.forceUpdate();
        return imgAlt;
    };

    swapMark(index){
        let oldImgAlt = this.removeMark(index);
        if(oldImgAlt === "correct"){
            this.wrongTickMark(index);
        }
        else if(oldImgAlt === "wrong"){
            this.correctTickMark(index);
        }
    };

    calculateScore(){
        let newScore = parseInt(this.state.correct, 10) - parseInt(this.state.incorrect, 10);
        if(newScore <= 0){
            this.state.score = 0;
        }
        else{
            this.state.score = newScore;
        }
        this.forceUpdate();
    };

    clearCounters(){
        //$("#data img").remove();
        this.setState({
            endIndex:0,
            score:0,
            correct:0,
            incorrect:0,
            highlighted:-1
        });
        this.state.paragraphs.map((paragraph,i)=>{
            paragraph.src = "";
            paragraph.alt = "";
            paragraph.highlighted = false;
        });
        this.forceUpdate();
    };

    mouseClick(i){
        this.state.paragraphs[i].highlighted=false;
        let imgAlt = this.state.paragraphs[i].alt;
        if(imgAlt === ""){
            this.wrongTickMark(i);
            if(i > this.state.endIndex){
                this.state.endIndex = i;
            }
        }
        else{
            this.swapMark(i);
        }
        this.calculateScore();
    };

    mouseDblClick(i){
        let oldImgAlt = this.removeMark(i);
        if (oldImgAlt !== "" && i === this.state.endIndex){
            let o = this.state.endIndex;
            let imgAlt;
            while(o > 0 && imgAlt === undefined) {
                o--;
                imgAlt = this.state.paragraphs[o].alt;
            }
            this.state.endIndex = i;
        }
        this.forceUpdate();
        this.calculateScore();
    };

    fillWithChecks(){
        let imgAlt;
        for(let i=0;i<this.state.endIndex;i++){
            imgAlt = this.state.paragraphs[i].alt;
            if(imgAlt === ""){
                this.correctTickMark(i);
            }
        }
        this.calculateScore();
    };



    async initializeData(){
        let csv = this.state.sessionData.gradingData;
        let tickArr = [];
        if(csv) {
           tickArr = csv.split(",");
        }
        let text = this.state.storyStarter.storyStarter;

        // Trim out new lines
        text = text.trim();
        // Convert text to word array by splitting at spaces
        let wordArr = text.split(/\s+/);
        // Ensures the tick array has its
        // length equal to the word count
        while(tickArr.length > wordArr.length){
            tickArr.pop();
        }
        while(tickArr.length < wordArr.length){
            tickArr.push("0");
        }

        // Create elements for each word and appends to container in order
        for(let i=0;i<wordArr.length;i++){
            let word = wordArr[i];
            let newPar = {
                index:i,
                word:word,
                src:"",
                alt:"",
                highlighted:false
            };
            await this.setState({
                paragraphs: [...this.state.paragraphs, newPar]
            });
            if(tickArr[i] === "1"){
                await this.correctTickMark(i);
                this.state.endIndex=i;
            }
            else if(tickArr[i] === "2"){
                await this.wrongTickMark(i);
                this.state.endIndex=i;
            }
        }
        // Calculates initial score
        this.forceUpdate();
        this.calculateScore();
        // Display the total word count
        this.state.totalWords = wordArr.length;
        this.forceUpdate();
    }

    startGrading = async(testId) => {
        await REST.getKSSession(testId).then(async(res) => {
            let ksSession = res.body;
            if (ksSession) {
                let bestScores = await REST.getStudentBestScores(ksSession.userId);
                let fileurl = ksSession.AV_FileName.indexOf("kidspeak") > -1 ? BUCKET_URL + ksSession.AV_FileName:BUCKET_URL+ "audio/kidspeak/" + ksSession.AV_FileName;
                await this.setState({
                    bestScores:bestScores.body,
                    ksSession:ksSession,
                    storyStarter: ksSession.kidspeak_content,
                    noteContent: ksSession.note,
                    audioSrc: fileurl,
                    sessionData:{
                        gradingData:ksSession.gradingData

                    }
                });

                await this.initializeData(ksSession.gradingData);

                this.audio.src = fileurl;
                this.audio.load();
                this.audio.addEventListener('loadedmetadata', () => {
                    console.log(this);
                    let mins = parseInt(this.audio.duration/60);
                    let secs = parseInt(this.audio.duration%60);
                    if(secs<=9){
                        secs = "0"+secs;
                    }
                    this.setState({duration: mins+':'+secs});
                });
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:'An Invalid Assessment ID has been provided.'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }

        }).catch(error => {
            console.log(error)
        });
    };


    //function to pause and play
    async pausePlay(){
        if(!this.audio.paused && !this.audio.ended){
            this.audio.pause();
            let playButtonHover = () => {
                this.setState({
                    playButton:{
                        backgroundImage:`url(${require("./style/images_VideoPlayer/play_over.png")})`
                    }
                });
            };
            let playButtonLeave = () => {
                this.setState({
                    playButton:{
                        backgroundImage:`url(${require("./style/images_VideoPlayer/play_off.png")})`
                    }
                });
            };
            //stop timer
            window.clearInterval(this.state.timer);
            this.setState({
                timer:null,
                playButton:{
                    backgroundImage:`url(${require("./style/images_VideoPlayer/play_over.png")})`
                },
                playButtonHover:playButtonHover,
                playButtonLeave:playButtonLeave
            });
        }
        else{
            //this.audio.playbackRate = 1;
            this.audio.play();
            await this.setState({
                analytics: {
                    type: TRACKING.KS_SCORE_PLAY,
                    metadata: {testId: this.state.testId},
                }
            });
            this.handleAnalytics();
            let playButtonHover = () => {
                this.setState({
                    playButton:{
                        backgroundImage:`url(${require("./style/images_VideoPlayer/pause_over.png")})`
                    }
                });
            };
            let playButtonLeave = () => {
                this.setState({
                    playButton:{
                        backgroundImage:`url(${require("./style/images_VideoPlayer/pause_off.png")})`
                    }
                });
            };
            //timer to update the current time
            let timer = setInterval(this.update,500);
            this.setState({
                timer:timer,
                playButton:{
                    backgroundImage:`url(${require("./style/images_VideoPlayer/pause_over.png")})`
                },
                playButtonHover:playButtonHover,
                playButtonLeave:playButtonLeave
            });

        }
    };

    //function update currentTime
    update(){
        if(!this.audio.ended){
            let playedMins = parseInt(this.audio.currentTime/60);
            let playedSecs = parseInt(this.audio.currentTime%60);
            let barSize = this.defaultBar.offsetWidth;

            //ensure secs is in double digits
            if(playedSecs<=9){
                playedSecs = "0"+playedSecs
            }

            let size = parseInt(this.audio.currentTime*barSize/this.audio.duration);
            this.setState({
                currentTime:playedMins+':'+playedSecs,
                progressBar:{
                    width: size.toString() + "px"
                }
            });

        }
        else{
            //reset the current time and change pause to play button
            window.clearInterval(this.state.timer); //stop timer
            this.setState({
                currentTime:"0:00",
                playButton:{
                    backgroundImage:`url(${require("./style/images_VideoPlayer/play_off.png")})`
                },
                progressBar:{
                    width:"0px"
                }
            });

        }
    }

    clickedBar(e){
        if(!this.audio.ended){
            let parentX = this.defaultBar.getBoundingClientRect().left;
            let width = e.pageX-parentX;
            let newtime = (width/this.defaultBar.offsetWidth)*this.audio.duration;
            console.log(newtime);
            this.audio.currentTime = newtime;
            //progressBar.style.width = width+"px";
            this.update();

        }

    }

    async deleteScore(){
            await this.setState({
                analytics: {
                    type: TRACKING.KS_SCORE_DELETE,
                    metadata: {testId: this.state.testId},
                }
            });
            await REST.deleteKidSpeakScore(this.state.testId).then(res => {
                this.handleAnalytics();
                this.props.history.goBack();
            });
    }

    deleteScoreConfirm = (confirm) =>{
        if(confirm) {
            this.deleteScore();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleTakeANote(){
        console.log("take a note");
        this.setState({
            modalDialogNote:true,
        });
    }

    handleNoteContentChange(event) {
        this.setState({ noteContent: event.target.value });
        event.preventDefault();
    }

    saveNote(){
        REST.updateKidSpeakNote({testId:this.state.testId, note:this.state.noteContent});
        this.setState({
            modalDialogNote:false,
        });
    }

    deleteNote(){
        this.setState({noteContent:''});
        REST.updateKidSpeakNote({testId:this.state.testId, note:''});
    }

    handleNoteClose(){
        this.setState({
            modalDialogNote:false,
        });
    }

    handleStudentClick = (student, classId) => {
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    getTarget(){
        this.setState({
            showPlayHint: false
        });
    }
    getTarget1() {
        this.setState({
            showClickWrongHint: false
        });
    }
    getTarget2() {
        this.setState({
            showClickLastHint: false
        });
    }
    getTarget3() {
        this.setState({
            showClickSingleHint: false
        });
    }
    getTarget4() {
        this.setState({
            showClickDoubleHint: false
        });
    }
    getTarget5() {
        this.setState({
            showSaveHint: false
        });
    }
    handleShowHints(){
        this.setState({
            showPlayHint:true,
            showClickWrongHint: true,
            showClickLastHint: true,
            showClickSingleHint: true,
            showClickDoubleHint: true,
            showSaveHint: true
        })
    }

    async handleSurveyBack(){
    }

    render() {

        let paragraphs = this.state.paragraphs.map((paragraph,i)=>{
            return <p key={i}
                      className={paragraph.highlighted ? "highlightSelect" : ""}
                      onClick={() => this.mouseClick(i)}
                      onDoubleClick={()=>this.mouseDblClick(i)}
                      >
                <img hidden={paragraph.alt===""} src={paragraph.src} alt={paragraph.alt}/>
                {paragraph.word}
            </p>;
        });

        let progressBar = "";


        return (
            <div className={"container-fluid bgGrey"} style={{paddingLeft:0,paddingRight:0}}>

                <div className={"container"}>
                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <DialogBox surveyModal role={'teacher'} app={'KSGrading'} userId={this.props.user.id} active={true} surveyBack={this.handleSurveyBack}/>
                    <DeleteDialogBox
                        confirmDelete={this.deleteScoreConfirm}
                        modalOpen={this.state.modalDialogDelete}
                        sectionContent={this.state.responseContent}
                        closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <Modal id="dialogBox" show={this.state.modalDialogNote}>
                        <div className="modal-content">
                            <div className={"row modal-body"}>
                                {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                                <div className="section">
                                    <h1 style={{paddingTop:0, marginTop:-10,marginBottom:15}}>Make a Note</h1>
                                    <textarea
                                        style={{width:500}}
                                        onChange={this.handleNoteContentChange}
                                        value={this.state.noteContent}
                                        placeholder={"please enter your note here"}
                                    ></textarea>
                                </div>
                                <div className="section" style={{marginTop:-40}}>
                                    <div className={"col-md-4"}>
                                        <a style={{float:'left'}} onClick={this.deleteNote} className="handBtn">
                                            <span>Delete</span>
                                        </a>
                                    </div>
                                    <div className={"col-md-4"}>
                                        <a style={{float:'left'}} onClick={this.saveNote} className="handBtn">
                                            <span>Close</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <div className={"center-block"} style={{maxWidth: '100%', marginTop: 10}}>
                        <div className={"col-sm-4"}> <h1><img src={logo_kidspeak} alt={"Kid Speak"} style={{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}/>  {this.props.lastStudent.user.firstname} {this.props.lastStudent.user.lastname}</h1>
                        </div>
                        <div className={"col-sm-8 tr"}>
                            <div className={"navbar"}> <ReportBugForm {...this.props} /><DropDownNotifications studentClick={this.handleStudentClick} {...this.props} /><a onClick={this.handleShowHints} className="handBtn"><span>Show Hints</span></a></div>
                        </div>
                        {/*<div className={"col-md-6 noPaddingLR"} style={{textAlign:'right',fontSize:18,fontFamily:'Neucha',letterSpacing:'1px',height:42,position:'relative',top:10}}>It took 0 minutes to complete this task</div>*/}
                        <div className="col-md-12 noPaddingLR">
                            <hr/>
                        </div>
                    </div>
                </div>
                <div className={"container"} style={{position:'relative', minHeight:'calc(100vh - 88px)', height:'100%'}}>
            <div id="appContainer" className={"ksGradingContainer col-md-12 newGradingClass"} style={{backgroundColor:'#FFF',backgroundImage:'initial'}}>
                <header className={"newGradingClass"} style={{marginTop:5,fontFamily: 'Neucha', letterSpacing: '1px'}}>{this.state.storyStarter.title}</header>
                <div id="whitebox" className={"newGradingClass"}>
                    <div hidden={!this.state.showClickWrongHint} className={"popoverCustom"}>
                        <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                            <div style={{display:"inline-block",float:'right'}}>
                                <img src={closeRedX} onClick={this.getTarget1} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                            </div>
                            <div style={{display:"inline-block"}}>
                                <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                            </div>
                        </div>
                        Click on incorrect words to mark ‘Wrong’
                        <div hidden={!this.state.showClickWrongHint} className={"arrowPointer arrowPointerInner"}></div>
                    </div>
                    <div hidden={!this.state.showClickLastHint} className={"popoverCustom popoverCustomRight"}>
                        <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                            <div style={{display:"inline-block",float:'right'}}>
                                <img src={closeRedX} onClick={this.getTarget2} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                            </div>
                            <div style={{display:"inline-block"}}>
                                <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                            </div>
                        </div>
                        Click the last word spoken
                    </div>
                    <div hidden={!this.state.showClickSingleHint} className={"popoverCustom popoverCustomRightBot"}>
                        <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                            <div style={{display:"inline-block",float:'right'}}>
                                <img src={closeRedX} onClick={this.getTarget3} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                            </div>
                            <div style={{display:"inline-block"}}>
                                <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                            </div>
                        </div>
                        Single click for Correct/ Wrong.
                    </div>
                    <div hidden={!this.state.showClickDoubleHint} className={"popoverCustom popoverCustomLeftBot"}>
                        <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                            <div style={{display:"inline-block",float:'right'}}>
                                <img src={closeRedX} onClick={this.getTarget4} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                            </div>
                            <div style={{display:"inline-block"}}>
                                <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                            </div>
                        </div>
                        Double click to remove scoring
                    </div>
                    <div id="data" className={"col-md-12 newGradingClass"} style={{paddingTop:5,overflowY:'auto',maxHeight:350}}>
                        {paragraphs}
                    </div>
                    <div className={"col-md-12 text-center"}>
                        Use the spacebar to pause/ play the audio. Click/ double-click words to toggle Correct/ Incorrect/ Ungraded.
                    </div>
                    <div id="wrapper" className={"newGradingClass col-md-12"} style={{backgroundColor:'initial'}}>
                        <audio id="track" ref={audio => this.audio = audio}/>
                        <div style={{position:'relative',textAlign:'left'}}>

                            <div hidden={!this.state.showPlayHint} className={"popoverCustom"}>
                                <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                                    <div style={{display:"inline-block",float:'right'}}>
                                        <img src={closeRedX} onClick={this.getTarget} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                                    </div>
                                    <div style={{display:"inline-block"}}>
                                        <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                                    </div>
                                </div>
                                Press Play icon to hear student
                            </div>
                            <div hidden={!this.state.showPlayHint} className={"arrowPointer"}></div>
                            <nav>
                            <button
                                onMouseOver={this.state.playButtonHover}
                                onMouseLeave={this.state.playButtonLeave}
                                onClick={()=>this.pausePlay()}
                                type="button"
                                id="playbutton"
                                style={
                                this.state.playButton.backgroundImage?{backgroundImage:this.state.playButton.backgroundImage}:{}
                            }/>
                            <span id="currentTime">{this.state.currentTime}</span>
                            <div ref={defaultBar => this.defaultBar = defaultBar} id="defaultBar" onClick={this.clickedBar}>
                                <div id="progressBar" style={
                                    this.state.progressBar.width?{width:this.state.progressBar.width}:{}
                                }>{progressBar}</div>
                            </div>
                            <span id="fullDuration">{this.state.duration}</span>
                        </nav>
                        </div>
                    </div>
                    <div id="options" className={"newGradingClass col-md-12"} style={{marginBottom:30}}>
                        <div className={"col-md-12 bgGrey"} style={{padding:15}}>
                            <table style={{width:'100%'}}>
                                <tbody>
                                <tr>

                                    <th>
                                        <img alt="correct" src={require("./style/images_WordMark/correct.png")} style={{position:'relative',top:-25,left:50}}/>
                                        <div className="fontSizeCalculationGrading calculationLabelPosition">Correct</div>
                                        <div id="correct" className="backgroundGradeCountBox">{this.state.correct}</div>
                                    </th>
                                    <th>
                                        <img alt="incorrect" src={require("../../assets/images/incorrect.png")} style={{position:'relative',top:-25,left:60}}/>
                                        <div className="fontSizeCalculationGrading calculationLabelPosition">Incorrect</div>
                                        <div id="" className={"backgroundGradeCountBox"}>{this.state.incorrect}</div>
                                    </th>
                                    <th>
                                        <div className="fontSizeCalculationGrading calculationLabelPosition">Total Words</div>
                                        <div id="" className={"backgroundGradeCountBox"}>{this.state.totalWords}</div>
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
                    <div className={"col-md-12 noPaddingLR"} style={{marginTop:30, marginBottom:30}}>
                        <div className={"col-lg-3 col-xs-3 col-md-3 noPaddingLR"}>
                            <a onClick={async ()=>{
                                await this.setState({
                                    analytics: {
                                        type: TRACKING.KS_SCORE_EXIT,
                                        metadata: {testId: this.state.testId},
                                    }
                                }); this.handleAnalytics(); this.props.history.push('../student')}} className="handBtn">
                                <span>Exit</span>
                            </a>
                        </div>
                        <div className={"col-lg-9 col-xs-9 col-md-9 noPaddingLR"} style={{textAlign:'right'}}>
                            <a onClick={this.handleNextTask} className="handBtn" style={{ display: this.state.handleNext ? 'inline-block': 'none'}}><span>Next Task</span></a>
                            <a onClick={this.handleTakeANote} className="handBtn" ><span>Make a Note</span></a>
                            <a onClick={this.submitKSSessionGrade} className="handBtn">
                                <span>Save</span>
                            </a>
                            <a onClick={this.fillWithChecks} className="handBtn">
                                <span>Auto Correct</span>
                            </a>
                            <a onClick={this.clearCounters} className="handBtn">
                                <span>Reset Grading</span>
                            </a>
                            <a onClick={() => {this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'})}} className="handBtn" style={{marginRight:0}}>
                                <span>Delete</span>
                            </a>
                        </div>
                    </div>
            </div>
            </div>
        );
    }
}
const actionToProps = dispatch => {
    return {
        updateStudent: async(student) => await dispatch(updateStudent(student))
    };
};
const mapStateToProps = state => ({
    lastStudent: state.teacherReducer.student,
});
export default connect(mapStateToProps,actionToProps)(withRouter(KSGrading));


// WEBPACK FOOTER //
// ./src/TeachersComponent/KSGrading/KSGrading.js